let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("flNbe")).then(() => parcelRequire('l8Zzc'));